"use client";

import { useTranslations } from "next-intl";
import styled from "styled-components";

const LegalContainer = styled.div<{ $onPage: boolean }>`
  height: fit-content;
  overflow: auto;
  max-height: 75vh;
  //   max-height: ${(props) => (props.$onPage ? "unset !important" : "75vh")};
  margin-bottom: 50px;
  padding: ${(props) => (props.$onPage ? "30px" : "10px")};

  h1 {
    margin: 0 0 20px 0;
  }

  p span {
    color: ${(props) => props.theme.black};
    font-weight: bold;
    text-decoration: none !important;
  }

  li span {
    text-decoration: underline;
  }

  .center-align {
    text-align: center;
    width: 100%;
  }

  .upper {
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  ol,
  ul {
    color: ${(props) => props.theme.black};
    margin: 10px 0 0 35px;
    font-size: 0.95rem;

    li {
      margin-bottom: 5px;
    }
  }

  p {
    color: ${(props) => props.theme.black};
    font-size: 0.95rem;
  }

  a {
    color: ${(props) => props.theme.link};

    &:hover {
      color: ${(props) => props.theme.black};
    }
  }

  @media (max-width: 425px) {
    max-height: 92vh;
    padding: ${(props) => (props.$onPage ? "20px" : "0")};
    padding: 0px 15px;
    font-size: 0.75rem !important;

    p,
    ol,
    ul {
      font-size: 0.75rem !important;
    }
  }
`;

export function ANZPrivacyPolicyContent({ onPage }: { onPage?: boolean }) {
  const t = useTranslations("termsOfAcceptance.anzPrivacyPolicy");

  return (
    <LegalContainer $onPage={onPage || false}>
      <h1>{t("title")}</h1>
      <p>
        {t.rich("sec1", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <h3>{t("minorsTitle")}</h3>
      <br />
      <p>{t("minorsDesc")}</p>
      <br />

      <h3>{t("collect")}</h3>
      <br />
      <p>{t("collect1")}</p>
      <br />

      <p>{t("collect2")}</p>
      <br />

      <p>{t("collect3")}</p>
      <br />

      <h3>{t("sensitiveInfo")}</h3>
      <br />
      <p>{t("sensitiveInfoDesc")}</p>
      <br />
      <h3>{t("auto")}</h3>
      <br />
      <p>{t("auto1")}</p>
      <br />
      <p>
        {t.rich("auto2", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto3", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t("auto4")}
        <span>
          <a href={t("allCookiesLink")}>{t("allCookiesLink")}</a>
        </span>
      </p>
      <br />
      <p>
        {t.rich("auto5", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto6", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto7", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto8", {
          link: (chunks) => (
            <span>
              <a href={chunks?.toString()}>{chunks}</a>
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto9", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("auto10", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <h3>{t("howWeUse")}</h3>
      <br />
      <p>{t("how1")}</p>
      <br />
      <p>{t("how2")}</p>
      <ul>
        <li style={{ fontWeight: "bold" }}>{t("howU1")}</li>
        <ul>
          <li>{t("howSub1")}</li>
          <li>{t("howSub2")}</li>
          <li>{t("howSub3")}</li>
        </ul>
      </ul>
      <p>{t("how3")}</p>
      <ul>
        <li style={{ fontWeight: "bold" }}>{t("howU2")}</li>
        <ul>
          <li>{t("howSub4")}</li>
          <li>{t("howSub5")}</li>
          <li>{t("howSub6")}</li>
          <li>{t("howSub7")}</li>
          <li>{t("howSub8")}</li>
          <li>{t("howSub9")}</li>
          <li>{t("howSub10")}</li>
        </ul>
      </ul>
      <p>{t("how4")}</p>
      <ul>
        <li style={{ fontWeight: "bold" }}>{t("howU3")}</li>
        <ul>
          <li>{t("howSub11")}</li>
          <li>{t("howSub12")}</li>
        </ul>
      </ul>
      <p>{t("personalize")}</p>
      <br />
      <p>{t("how5")}</p>
      <ul>
        <li>
          {t("affiliates1")}{" "}
          <span style={{ textDecoration: "none" }}>
            <a href={t("secLink")}>{t("secText")}.</a>
          </span>{" "}
          {t.rich("affiliates2", {
            link: (chunks) => (
              <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                {chunks}
              </span>
            ),
          })}
        </li>
        <li>{t("howSub13")}</li>
        <li>{t("howSub14")}</li>
        <li>{t("howSub15")}</li>
      </ul>
      <p>{t("addition")}</p>
      <br />
      <p>{t("automaticInfoColl")}</p>
      <br />
      <p>{t("addition2")}</p>
      <br />
      <h3>{t("choicesAccess")}</h3>
      <br />
      <h3>{t("choicesSubHead")}</h3>
      <br />
      <p>{t("choicesDesc")}</p>
      <ul>
        <li>
          {t.rich("choiceBullet1", {
            link: (chunks) => {
              const text = chunks!.toString();
              if (text.includes("@")) {
                return <a href={`mailto:${text}`}>{text}</a>;
              }
              return (
                <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                  {chunks}
                </span>
              );
            },
          })}
        </li>
        <li>
          {t.rich("choiceBullet2", {
            link: (chunks) => {
              const text = chunks!.toString();
              if (text.includes("@")) {
                return <a href={`mailto:${text}`}>{text}</a>;
              }
              return (
                <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                  {chunks}
                </span>
              );
            },
          })}
        </li>
        <li>
          {t.rich("choiceBullet3", {
            link: (chunks) => (
              <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                {chunks}
              </span>
            ),
          })}
        </li>
      </ul>
      <p>{t("comply")}</p>
      <br />
      <h3>{t("personalInfoHead")}</h3>
      <br />
      <p>{t("personalInfoText")}</p>
      <br />
      <h3>{t("crossBorder")}</h3>
      <br />
      <p>{t("crossBorderText")}</p>
      <br />
      <h3>{t("security")}</h3>
      <br />
      <p>{t("securityText")}</p>
      <br />
      <h3>{t("retentionPeriod")}</h3>
      <br />
      <p>{t("retentionPeriodText")}</p>
      <br />
      <h3>{t("thirdParty")}</h3>
      <br />
      <p>{t("thirdText")}</p>
      <br />
      <h3>{t("contactAUS")}</h3>
      <br />
      <p>
        {t.rich("contactAUSText", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("contactQuestion", {
          link: (chunks) => {
            const text = chunks!.toString();
            if (text.includes("@")) {
              return <a href={`mailto:${text}`}>&nbsp;{text}</a>;
            }
            return (
              <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                {chunks}
              </span>
            );
          },
        })}
      </p>
      <p style={{ fontWeight: "bold", marginTop: "10px" }}>{t("name")}</p>
      <p style={{ fontWeight: "bold" }}>{t("address")}</p>
      <br />
      <h3>{t("contactNZ")}</h3>
      <br />
      <p>
        {t.rich("contactNZText", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>
        {t.rich("contactQuestion", {
          link: (chunks) => {
            const text = chunks!.toString();
            if (text.includes("@")) {
              return <a href={`mailto:${text}`}>&nbsp;{text}</a>;
            }
            return (
              <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                {chunks}
              </span>
            );
          },
        })}
      </p>
      <p style={{ fontWeight: "bold", marginTop: "10px" }}>{t("name")}</p>
      <p style={{ fontWeight: "bold" }}>{t("address")}</p>
      <br />
      <h3>{t("complaintsAU")}</h3>
      <br />
      <p>
        {t.rich("complaintsAUtext", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <ul>
        <li>{t("compaintsUl1")}</li>
        <li>{t("complaintsUl2")}</li>
        <li>{t("complaintsUl3")}</li>
      </ul>
      <p>{t("weWill")}</p>
      <ul>
        <li>{t("acknowledge")}</li>
        <li>{t("provide")}</li>
      </ul>
      <p>{t("complaintsNote")}</p>
      <br />
      <p>{t("furtherInfo")}</p>
      <ul>
        <li>
          {t.rich("privacyHotline", {
            link: (chunks) => {
              const text = chunks!.toString();
              // Check if it's a phone number (contains only digits and spaces/hyphens)
              if (/^[\d\s\-]+$/.test(text.trim())) {
                return (
                  <a href={`tel:${text.replace(/\s/g, "")}`}>&nbsp;{text}</a>
                );
              }
              return (
                <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                  {chunks}
                </span>
              );
            },
          })}
        </li>
        <li>
          {t.rich("website", {
            link: (chunks) => {
              const text = chunks!.toString();
              return <a href={`https://${text}`}>&nbsp;{text}</a>;
            },
          })}
        </li>
        <li>
          {t.rich("number", {
            link: (chunks) => {
              const text = chunks!.toString();
              if (text.includes("@")) {
                return <a href={`mailto:${text}`}>&nbsp;{text}</a>;
              }
              return (
                <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                  {chunks}
                </span>
              );
            },
          })}
        </li>
        <li>{t("write")}</li>
      </ul>
      <br />
      <h3>{t("complaintsNZ")}</h3>
      <br />
      <p>
        {t.rich("complaintsNZtext", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <ul>
        <li>{t("nzBullet1")}</li>
        <li>{t("nzBullet2")}</li>
        <li>{t("nzBullet3")}</li>
      </ul>
      <p>{t("weWill")}</p>
      <ul>
        <li>{t("acknowledge")}</li>
        <li>{t("provide")}</li>
      </ul>
      <p>{t("nzNote")}</p>
      <br />
      <p>{t("nzFurther")}</p>
      <ul>
        <li>
          {t.rich("nzPhone", {
            link: (chunks) => {
              const text = chunks!.toString();
              if (/^[\d\s\-]+$/.test(text.trim())) {
                return <a href={`tel:${text.replace(/\s/g, "")}`}>{text}</a>;
              }
              return (
                <span style={{ textDecoration: "none", fontWeight: "bold" }}>
                  {chunks}
                </span>
              );
            },
          })}
        </li>
        <li>
          {t.rich("nzSite", {
            link: (chunks) => {
              const text = chunks!.toString();
              return <a href={`https://${text}`}>{text}</a>;
            },
          })}
        </li>
        <li>{t("nzWrite")}</li>
      </ul>
      <br />
      <h3>{t("updates")}</h3>
      <br />
      <p>
        {t.rich("updatesText", {
          link: (chunks) => (
            <span style={{ textDecoration: "none", fontWeight: "bold" }}>
              {chunks}
            </span>
          ),
        })}
      </p>
      <br />
      <p>{t("codeAu")}</p>
      <p>{t("codeNz")}</p>
    </LegalContainer>
  );
}
